import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Checkbox } from "antd-mobile-v2";
import tool from "../../api/tool";
import "./index.less";
import { btnData } from "./const";
export default class Comiplat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isbtn: true,
    };
  }
  componentDidMount() {}
  render() {
    return (
      <div className="comiplat-wrapper">
        {btnData.map((item, index) => {
          return (
            <div
              className="comiplat-item"
              key={index}
              style={{ backgroundColor: item.bgColor }}
              onClick={() => {
                tool.remove("asscateData");
                tool.remove("submitData");
                tool.remove("formData");
                this.props.history.push({
                  pathname: item.push,
                  state: {
                    comiplatType: item.applyType,
                  },
                });
              }}
            >
              <div
                className="item-image"
                style={{
                  background: `url(${item.url})`,
                  backgroundSize: "100% 100%",
                }}
              ></div>
              <div style={{ marginLeft: "0.2rem" }}>{item.value}</div>
            </div>
          );
        })}
      </div>
    );
  }
}
